module.exports = __webpack_public_path__ + "img/9.126c5f66.png";